<template>
  <div>
    <div class="d-flex" id="wrapper" :class="{ toggled: isSidebar }">
      <app-sidebar></app-sidebar>
      <div id="page-content-wrapper" style="width:100%">
        <i
          class="material-icons"
          id="menu-toggle"
          @click="isSidebar = !isSidebar"
          >view_headline</i
        >
        <app-navbar></app-navbar>
        <div class="container-fluid mt-5" id="grad1">
          <!-- breadcrumb and title row starts -->
          <div class="row">
            <div class="col-sm-12">
              <vs-breadcrumb
                align="left"
                :items="[
                  { title: 'You are here : ' },
                  {
                    title: 'Dashboard',
                    url: '/#/dashboard/Admin/adminDashboard'
                  },

                  {
                    title: 'Training Wizard',
                    active: true
                  }
                ]"
              ></vs-breadcrumb>
            </div>
            <div class="col-sm-12">
              <div class="heading mt-3">
                <h3 class="text-secondary">Training Wizard</h3>
              </div>
            </div>
          </div>
          <!-- breadcrumb and title row Ends -->
          <div class="row justify-content-center mt-0">
            <div class="col-11 text-center p-0 mt-3 mb-2">
              <div class="card px-0 pb-0 mt-3 mb-3">
                <div class="row">
                  <div class="col-md-12 mx-0">
                    <form id="msform">
                      <!-- progressbar -->
                      <ul id="progressbar">
                        <li class="completed" id="NewTraining">
                          <strong>Training Assignment</strong>
                        </li>
                        <li class="completed" id="PoAssignment">
                          <strong>P.O Assignment</strong>
                        </li>
                        <li class="completed" id="TrainingInformation">
                          <strong>Training Information</strong>
                        </li>
                        <li class="completed" id="TrainerRegistration">
                          <strong>Trainer Registration</strong>
                        </li>
                        <li class="completed" id="TrainingAgenda">
                          <strong>Training Agenda</strong>
                        </li>
                        <li class="completed" id="Trainingmaterial">
                          <strong>Upload Material</strong>
                        </li>
                        <li class="completed" id="TrainingAssessments">
                          <strong>Training Assessments</strong>
                        </li>
                        
                        <li class="completed" id="TraineeRegistration">
                          <strong>Trainee Registration</strong>
                        </li>
                        <li class="completed" id="AssessmentReview">
                          <strong>Assessment Review</strong>
                        </li>
                        <li class="active" id="Completion">
                          <strong>Completion</strong>
                        </li>
                      </ul>
                      <!-- fieldsets -->
                      <fieldset
                        style="text-align: left;padding: 30px; min-height: 300px"
                      >
                        <h5 class="text-center mt-5">
                          Training Completed Successfully
                        </h5>
                        <!-- row 1 starts  -->
                        <div
                          class="row mt-5 mb-1 d-flex justify-content-center"
                        >
                          <button class="mb-3">
                            <router-link
                              :to="{
                                path: '/dashboard/admin/brief_training_report',
                                query: { trainingId: this.trainingCode }
                              }"
                              class="btn custom-button"
                              >Brief Training Details</router-link
                            >
                          </button>
                          <button class="ml-3 mb-3">
                            <router-link
                              :to="{
                                path: '/dashboard/admin/analysis-report',
                                query: { trainingId: this.trainingCode }
                              }"
                              class="btn custom-button"
                              >Overall Training Analysis</router-link
                            >
                          </button>
                          <!-- <button class="ml-3 mb-3">
                            <router-link
                              :to="{
                                path: '/dashboard/admin/analysis-post-report',
                                query: { trainingId: this.trainingCode }
                              }"
                              class="btn custom-button"
                              >Overall Post Training Analysis</router-link
                            >
                          </button> -->

                          <button class=" ml-3 mb-3">
                            <router-link
                              :to="{
                                path:
                                  '/dashboard/admin/individual_analysis_report',
                                query: { trainingId: this.trainingCode }
                              }"
                              class="btn custom-button"
                              >Individual Training Analysis</router-link
                            >
                          </button>
                        </div>
                        <!-- row 1 ends -->
                        <!-- Review and Edit -->
                        <div class="row d-flex justify-content-center">
                          <button class="ml-3 mb-1">
                          <router-link
                            :to="{ path:'/dashboard/admin/trainingWizard'}"
                            class="btn danger"
                            >Review & Edit</router-link>
                          </button>
                        </div>
                      </fieldset>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
// import axios from "axios";
export default {
  data: () => ({
    isSidebar: false,
    trainingCode: ""
  }),
  mounted() {
    this.trainingCode = this.$route.query.trainingId;
  },
  methods: {
    openLoading() {
      this.$vs.loading({
        type: "material"
      });
    },
    closeLoading() {
      this.$vs.loading.close();
    },
    printReport: function() {
      window.print();
    }
  },
  components: {
    "app-navbar": Navbar,
    "app-sidebar": Sidebar
  }
};
</script>

<style scoped>
.custom-button {
  line-height: 2.6;
  font-size: 13px;
  height: 50px;
  background: #06a6e0;
  color: #ffffff;
  font-weight: 700;
}
.custom-button-review {
  line-height: 2.6;
  font-size: 13px;
  height: 50px;
  background: #eaedee;
  color: #ffffff;
  font-weight: 700;
}
#progressbar .completed {
  color: #06a6e0 !important;
}

#progressbar li.completed:before,
#progressbar li.completed:after {
  background: #06a6e0 !important;
}

#grad1 {
  background-color: #fff;
}

#msform {
  text-align: center;
  position: relative;
  margin-top: 20px;
}

#msform fieldset .form-card {
  background: white;
  border: 0 none;
  border-radius: 0px;
  box-shadow: 0 2px 2px 2px rgba(0, 0, 0, 0.2);
  padding: 20px 40px 30px 40px;
  box-sizing: border-box;
  width: 94%;
  margin: 0 3% 20px 3%;
  position: relative;
}

#msform fieldset {
  padding: 10px;
  background: #f7f7f7 !important;
  border: 0 none;
  border-radius: 2rem;
  box-sizing: border-box;
  width: 100%;
  margin: 0;
  border: 2px solid #ccc;
  padding-bottom: 20px;
  position: relative;
}

#msform fieldset:not(:first-of-type) {
  display: none;
}

#msform fieldset .form-card {
  text-align: left;
  color: #9e9e9e;
}

/* #msform input,
#msform textarea {
    padding: 0px 8px 4px 8px;
    border: none;
    border-bottom: 1px solid #ccc;
    border-radius: 0px;
    margin-bottom: 25px;
    margin-top: 2px;
    width: 100%;
    box-sizing: border-box;
    font-family: montserrat;
    color: #2c3e50;
    font-size: 16px;
    letter-spacing: 1px;
}

#msform input:focus,
#msform textarea:focus {
    -moz-box-shadow: none !important;
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
    border: none;
    font-weight: bold;
    border-bottom: 2px solid skyblue;
    outline-width: 0;
} */

#msform .action-button {
  width: 100px;
  background: skyblue;
  font-weight: bold;
  color: white;
  border: 0 none;
  border-radius: 0px;
  cursor: pointer;
  padding: 10px 5px;
  margin: 10px 5px;
}

#msform .action-button:hover,
#msform .action-button:focus {
  box-shadow: 0 0 0 2px white, 0 0 0 3px skyblue;
}

#msform .action-button-previous {
  width: 100px;
  background: #616161;
  font-weight: bold;
  color: white;
  border: 0 none;
  border-radius: 0px;
  cursor: pointer;
  padding: 10px 5px;
  margin: 10px 5px;
}

#msform .action-button-previous:hover,
#msform .action-button-previous:focus {
  box-shadow: 0 0 0 2px white, 0 0 0 3px #616161;
}

select.list-dt {
  border: none;
  outline: 0;
  border-bottom: 1px solid #ccc;
  padding: 2px 5px 3px 5px;
  margin: 2px;
}

select.list-dt:focus {
  border-bottom: 2px solid skyblue;
}

.card {
  z-index: 0;
  border: none;
  border-radius: 0.5rem;
  position: relative;
}

.fs-title {
  font-size: 25px;
  color: #2c3e50;
  margin-bottom: 10px;
  font-weight: bold;
  text-align: left;
}

#progressbar {
  margin-bottom: 30px;
  overflow: hidden;
  color: lightgrey;
}

#progressbar .active {
  color: #000000;
}

#progressbar li {
  list-style-type: none;
  font-size: 12px;
  width: 9.5%;
  float: left;
  text-align:center;
  position: relative;
}

#progressbar #NewTraining:before {
  content: "1";
}

#progressbar #PoAssignment:before {
  content: "2";
}

#progressbar #TrainingInformation:before {
  content: "3";
}

#progressbar #TrainingAgenda:before {
  content: "4b";
}
#progressbar #Trainingmaterial:before {
  content: "4c";
}

#progressbar #TrainingAssessments:before {
  content: "4d";
}

#progressbar #TrainerRegistration:before {
  content: "4a";
}

#progressbar #TraineeRegistration:before {
  content: "4e";
}

#progressbar #AssessmentReview:before {
  content: "5";
}

#progressbar #Completion:before {
  content: "6";
}

#progressbar li:before {
  width: 35px;
  height: 35px;
  line-height: 30px;
  display: block;
  font-size: 18px;
  color: #ffffff;
  background: lightgray;
  border-radius: 50%;
  margin: 0 auto 10px auto;
  padding: 2px;
}

#progressbar li:after {
  content: "";
  width: 100%;
  height: 2px;
  background: lightgray;
  position: absolute;
  left: 0;
  top: 17px;
  z-index: -1;
}

#progressbar li.active:before,
#progressbar li.active:after {
  background: #000000;
}

.radio-group {
  position: relative;
  margin-bottom: 25px;
}

.radio {
  display: inline-block;
  width: 204;
  height: 104;
  border-radius: 0;
  background: lightblue;
  box-shadow: 0 2px 2px 2px rgba(0, 0, 0, 0.2);
  box-sizing: border-box;
  cursor: pointer;
  margin: 8px 2px;
}

.radio:hover {
  box-shadow: 2px 2px 2px 2px rgba(0, 0, 0, 0.3);
}

.radio.selected {
  box-shadow: 1px 1px 2px 2px rgba(0, 0, 0, 0.1);
}

.fit-image {
  width: 100%;
  object-fit: cover;
}
</style>
